import React, { useState } from 'react';
import './MaintenancePage.css';

const content = {
  fr: {
    language: 'العربية',
    status: 'Lancement prochain',
    kicker: 'UNE NOUVELLE EXPÉRIENCE DE SANTÉ',
    title: <>SmartDoctors<br />prépare votre santé de demain.</>,
    lead: "Nous travaillons actuellement à réunir vos informations médicales, votre SmartDoctors Pass et l'accès à des médecins qualifiés dans une expérience plus simple, plus sûre et plus humaine.",
    features: [
      'Vos données de santé réunies en un seul endroit',
      'Un accès sécurisé avec votre SmartDoctors Pass',
      'Des médecins et des rendez-vous plus accessibles',
    ],
    soon: 'Nous serons bientôt en ligne.',
    thanks: 'Merci pour votre confiance et votre patience.',
    footer: 'SmartDoctors — Votre santé. Vos données. Votre contrôle.',
    whatsapp: 'Nous contacter sur WhatsApp',
    loginAlt: 'Connexion au dossier médical SmartDoctors',
  },
  ar: {
    language: 'Français',
    status: 'الإطلاق قريباً',
    kicker: 'تجربة صحية رقمية جديدة',
    title: <>SmartDoctors<br />يُحضّر لصحتكم في المستقبل.</>,
    lead: 'نعمل حالياً على جمع معلوماتكم الطبية وبطاقة SmartDoctors Pass وإمكانية الوصول إلى أطباء مؤهلين في تجربة واحدة أكثر سهولة وأماناً وإنسانية.',
    features: [
      'جميع بياناتكم الصحية في مكان واحد',
      'وصول آمن باستخدام بطاقة SmartDoctors Pass',
      'أطباء ومواعيد طبية في متناولكم بسهولة',
    ],
    soon: 'سنكون معكم قريباً.',
    thanks: 'شكراً لثقتكم وصبركم.',
    footer: 'SmartDoctors — صحتكم. بياناتكم. أنتم من يتحكم بها.',
    whatsapp: 'تواصلوا معنا عبر واتساب',
    loginAlt: 'تسجيل الدخول إلى الملف الطبي SmartDoctors',
  },
};

function MedicalVisual({ loginAlt }) {
  return (
    <div className="maintenance-visual">
      <span className="visual-orbit visual-orbit-one" aria-hidden="true" />
      <span className="visual-orbit visual-orbit-two" aria-hidden="true" />
      <span className="visual-dot visual-dot-one" aria-hidden="true" />
      <span className="visual-dot visual-dot-two" aria-hidden="true" />
      <div className="visual-phone">
        <span className="phone-speaker" aria-hidden="true" />
        <img className="visual-login-image" src="/portal-login.jpeg" alt={loginAlt} />
      </div>
      <div className="visual-card" aria-hidden="true">
        <img src="/Logo.png" alt="" />
        <div className="card-bottom">
          <span>CARTE PATIENT</span>
          <strong>)))</strong>
        </div>
      </div>
      <div className="visual-badge" aria-hidden="true">NFC</div>
    </div>
  );
}

function WhatsAppIcon() {
  return (
    <svg viewBox="0 0 32 32" aria-hidden="true">
      <path fill="currentColor" d="M16.02 3A12.8 12.8 0 0 0 5.1 22.48L3.4 29l6.68-1.74A12.85 12.85 0 1 0 16.02 3Zm0 23.33a10.6 10.6 0 0 1-5.4-1.48l-.39-.23-3.96 1.03 1.06-3.86-.25-.4a10.56 10.56 0 1 1 8.94 4.94Zm5.8-7.9c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.31-.82 1.03-1 1.24-.19.21-.37.24-.69.08-.31-.16-1.33-.49-2.54-1.57a9.47 9.47 0 0 1-1.76-2.19c-.18-.32-.02-.49.14-.65.14-.14.32-.37.47-.55.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.71-1.72-.98-2.35-.25-.62-.52-.54-.71-.55h-.61c-.21 0-.55.08-.84.4-.29.31-1.11 1.08-1.11 2.64s1.14 3.06 1.29 3.27c.16.21 2.24 3.42 5.43 4.8.76.32 1.35.52 1.81.67.76.24 1.45.21 2 .13.61-.09 1.88-.77 2.14-1.51.27-.74.27-1.37.19-1.51-.08-.13-.29-.21-.61-.37Z" />
    </svg>
  );
}

export default function MaintenancePage() {
  const [language, setLanguage] = useState('fr');
  const copy = content[language];
  const isArabic = language === 'ar';

  return (
    <main className={`maintenance-page${isArabic ? ' maintenance-page-ar' : ''}`}>
      <div className="maintenance-glow maintenance-glow-left" />
      <div className="maintenance-glow maintenance-glow-right" />

      <header className="maintenance-header">
        <img src="/Logo.png" alt="SmartDoctors" className="maintenance-logo" />
        <div className="maintenance-header-actions">
          <button
            type="button"
            className="maintenance-language"
            onClick={() => setLanguage(isArabic ? 'fr' : 'ar')}
            lang={isArabic ? 'fr' : 'ar'}
          >
            <span aria-hidden="true">🌐</span> {copy.language}
          </button>
          <div className="maintenance-status"><span /> {copy.status}</div>
        </div>
      </header>

      <section className="maintenance-content">
        <div className="maintenance-copy" dir={isArabic ? 'rtl' : 'ltr'}>
          <p className="maintenance-kicker">{copy.kicker}</p>
          <h1>{copy.title}</h1>
          <p className="maintenance-lead">{copy.lead}</p>

          <div className="maintenance-features">
            {copy.features.map((feature, index) => (
              <div key={feature}><span>0{index + 1}</span><p>{feature}</p></div>
            ))}
          </div>

          <div className="maintenance-soon">
            <span className="soon-pulse" />
            <p><strong>{copy.soon}</strong><br />{copy.thanks}</p>
          </div>
        </div>

        <MedicalVisual loginAlt={copy.loginAlt} />
      </section>

      <footer className="maintenance-footer" dir={isArabic ? 'rtl' : 'ltr'}>
        <p>{copy.footer}</p>
        <p>smartdoctors.tech</p>
      </footer>

      <a
        className="maintenance-whatsapp"
        href="https://wa.me/491622982160"
        target="_blank"
        rel="noreferrer"
        aria-label={copy.whatsapp}
        title={copy.whatsapp}
      >
        <WhatsAppIcon />
      </a>
    </main>
  );
}
